import { memo, ReactNode } from 'react';
import useStyles from '../useStyles';

import { CustomizedTypography } from '@components/Customized';

interface LeftSideHeaderProps {
  children?: ReactNode;
  label: () => string;
}

const LeftSideHeader = ({ children, label }: LeftSideHeaderProps) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes['Dashboard-Left-header']}>
        <CustomizedTypography fontWeight="bold" variant="h4">
          {label()}
        </CustomizedTypography>
        {children ? children : null}
      </div>
    </>
  );
};

export default memo(LeftSideHeader, (prev, curr) => {
  return prev.label() === curr.label();
});
